export function getSystemLocale() {
  return getSystemLocaleWeb();
}

function getSystemLocaleWeb() {
  if (window.navigator.language) {
    return window.navigator.language;
  } else if (window.navigator.languages) {
    return window.navigator.languages[0];
  }

  return "en-US";
}

export function getLanguageComponent(language: string): string {
  const [lang] = language.split("-");

  return lang;
}

export function hasDialect(language: string): boolean {
  const [, dialect] = language.split("-");

  return !!dialect;
}

export function normalizeLanguage(language: string): string {
  const [lang, dialect] = language.split("-");

  if (lang && !dialect) {
    return lang.toLowerCase();
  }

  return `${lang.toLowerCase()}-${dialect.toUpperCase()}`;
}
